export default function Facilities() {
  const facilities = [
    {
      icon: 'fa-map-marked-alt',
      title: '전국 물류 네트워크',
      description: '수도권, 충청, 영남, 호남 주요 거점',
      number: '4개 권역',
      color: 'from-blue-500 to-cyan-500'
    },
    {
      icon: 'fa-industry',
      title: '물류센터 규모',
      description: '총 보관 면적',
      number: '50,000㎡',
      color: 'from-cyan-500 to-teal-500'
    },
    {
      icon: 'fa-thermometer-half',
      title: '특수 보관 시설',
      description: '상온/냉장/냉동 보관 가능',
      number: '3 Zone',
      color: 'from-teal-500 to-emerald-500'
    },
    {
      icon: 'fa-robot',
      title: '자동화 시스템',
      description: '최신 WMS 및 자동 분류 시스템',
      number: '100% 자동화',
      color: 'from-emerald-500 to-green-500'
    }
  ];

  return (
    <section id="facilities" className="py-20 bg-slate-900 text-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <p className="text-cyan-400 font-semibold mb-2 tracking-wider text-sm">INFRASTRUCTURE</p>
          <h2 className="text-4xl font-bold mb-4">최첨단 물류 인프라</h2>
          <p className="text-slate-300 text-lg">전국 거점 물류센터와 최신 자동화 시스템</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {facilities.map((facility, index) => (
            <div
              key={index}
              className="relative bg-slate-800 rounded-xl p-8 overflow-hidden group hover:transform hover:scale-105 transition-all duration-300"
            >
              <div className={`absolute inset-0 bg-gradient-to-br ${facility.color} opacity-0 group-hover:opacity-10 transition-opacity`}></div>
              
              <div className="relative z-10">
                <div className="w-14 h-14 bg-slate-700 rounded-lg flex items-center justify-center mb-6 group-hover:bg-cyan-600 transition-colors">
                  <i className={`fas ${facility.icon} text-2xl text-cyan-400 group-hover:text-white`}></i>
                </div>
                
                <h3 className="text-lg font-bold mb-3">{facility.title}</h3>
                <p className="text-slate-400 text-sm mb-4">{facility.description}</p>
                <div className="text-3xl font-bold text-cyan-400">{facility.number}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}